import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { IStore } from 'src/interfaces/store';
import { IMake } from 'src/interfaces/make';
import { uniq } from 'lodash';

interface MakeExtractor {
    extract(make: IMake): string[];
}

class GroupedMakesExtractor implements MakeExtractor {
    extract(make: IMake): string[] {
        return make?.groupedMakes || [];
    }
}

class SingleMakeExtractor implements MakeExtractor {
    extract(make: IMake): string[] {
        const id = getDocumentId(make);
        return id ? [id] : [];
    }
}

const makeExtractors: MakeExtractor[] = [
    new GroupedMakesExtractor(),
    new SingleMakeExtractor(),
];

/**
 * Extracts the makes ids from the stores
 * @param stores - The stores to extract the makes ids from
 * @returns The makes ids without duplicates
 */
export const extractMakesIdsByStores = (stores: IStore[]) => {
    if (!stores || stores.length === 0) return [];

    const allIds = stores.reduce<string[]>((acc, store) => {
        if (!store.make) return acc;

        const extractedIds = makeExtractors.reduce<string[]>(
            (ids, extractor) => {
                return [...ids, ...extractor.extract(store.make)];
            },
            []
        );

        return [...acc, ...extractedIds];
    }, []);

    return uniq(allIds);
};
